import React from 'react';
import PropTypes from 'prop-types';

//CSS読み込み
import './css/TextBox.css';

//定数定義読み込み
import * as Const from '../Const.js';

//各種モジュールを読み込み
import ValidateTextBox  from './ValidateTextBox.js';

class TextBox extends ValidateTextBox {
    //コンストラクタ
    constructor(props) {
        super(props);

        //各コールバック関数を登録
        this.handleFocus  = this.handleFocus.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur   = this.handleBlur.bind(this);

        // 半角validationは、IMEを無効にする
        let stateType = props.type;
        if (stateType === Const.TEXT_TYPE_TEXT
            && navigator.userAgent.indexOf('iPhone') < 0
            && navigator.userAgent.indexOf('Android') < 0) {
            //※電話以外のデバイスでは、input type="tel" で対応
            for (let i = this.props.validate.length - 1; i >= 0; i--) {
                if (this.props.validate[i] >= 10) {
                    stateType = "tel";
                    break;
                }
            }
        }
        //入力情報設定
        this.state = {
            id                  : props.id,
            type                : stateType,
            value               : props.value,
            classname           : props.classname,
            defaultclassname    : props.classname,
            length              : props.length,
            currentlength       : 0,
            validate_id         : props.validate_id,
            validate            : props.validate,
            state               : props.state,
            validatestate       : props.validatestate,
            callback            : props.callback,
            placeholder         : props.placeholder,
            initialize          : false
        };
    }

    // フォーカスされたとき
    handleFocus(event) {
        let val = document.getElementById(this.state.id).value;
        this.setState({value: val, currentlength: val.length, placeholder: ''});
        this.state.callback(Const.EVENT_INPUT_FOCUS, this.state.id, "");
    }

    // 入力されたとき
    handleChange(event) {
        this.state.callback(Const.EVENT_INPUT_CHANGE, this.state.id, "");
        this.setState({value: event.target.value, currentlength: event.target.value.length});
    }

    // フォーカスを外したとき
    handleBlur(event) {
        // 半角validationは、自動変換する
        var targetVal = this.state.value;
        for (let i = this.state.validate.length - 1; i >= 0; i--) {
            if (this.state.validate[i] >= 10) {
                targetVal = this.state.value.replace(/[Ａ-Ｚａ-ｚ０-９！-～]/g,
                    function( tmpStr ) {
                      return String.fromCharCode( tmpStr.charCodeAt(0) - 0xFEE0 );
                    }
                ); 
                break;
            }
        }
        // バリデートチェックを行う
        var check = true;
        for (var i = 0; i < this.state.validate.length; i++) {
            if (this.state.validate[i] < 10) {
                if (this.state.validate[i] === Const.TEXT_VALIDATE_LENGTH_MIN) {
                    if (Number(this.state.length[0]) === 0 && targetVal.length === 0) break;      // 最低文字数が0の場合他のバリデートを飛ばす
                    if (super.validate(this.state.validate[i], targetVal, this.state.length[0]) === false) {
                        check = false;
                        break;
                    }
                }
                else if (this.state.validate[i] === Const.TEXT_VALIDATE_LENGTH_MAX) {
                    if (super.validate(this.state.validate[i], targetVal, this.state.length[1]) === false) {
                        check = false;
                        break;
                    }
                }
            } else if (this.state.validate[i] === Const.TEXT_VALIDATE_FIRST_POINT
                || this.state.validate[i] === Const.TEXT_VALIDATE_SECOND_POINT_HALF
                || this.state.validate[i] === Const.TEXT_VALIDATE_FOURTH_POINT
                || this.state.validate[i] === Const.TEXT_VALIDATE_EIGHTH_POINT
                || this.state.validate[i] === Const.TEXT_VALIDATE_KIND_SIGNED_NUMBER) {
                if (super.validate(this.state.validate[i], targetVal, this.state.length[1]) === false) {
                    check = false;
                    break;
                }
            } else if (super.validate(this.state.validate[i], targetVal) === false) {
                check = false;
                break;
            } else if (this.state.validate[i] === Const.TEXT_VALIDATE_KIND_NUMBER_ALPHA) {
                targetVal = targetVal.toUpperCase();
            }
        }

        // 入力状況に応じて、見た目を変更する
        if (targetVal.length === 0) {
            this.setState({classname: this.state.defaultclassname + " noinput", value: targetVal, currentlength: 0, placeholder: this.props.placeholder});
        }
        else {
            this.setState({classname: this.state.defaultclassname + " inputs", value: targetVal, currentlength: 0, placeholder: this.props.placeholder});
        }

        // バリデート状況を配置元に戻す
        document.getElementById(this.state.id).value = targetVal;
        this.state.validatestate = check;
        this.state.callback(Const.EVENT_INPUT_BLUR, this.state.id, check, targetVal);
    }

    //画面描画
    render() {
        var value = this.props.state === Const.TEXT_STATUS_INITIALIZE || (this.props.state === Const.TEXT_STATUS_ERROR && this.props.befstate === Const.TEXT_STATUS_INITIALIZE) ? this.props.value : this.state.value;
        var classname = this.props.state === Const.TEXT_STATUS_ERROR ? this.state.defaultclassname + " inputerror" : this.props.disabled === true ? this.state.defaultclassname + " noinput" : value === "" ? this.state.defaultclassname + " noinput" : this.state.defaultclassname + " inputs";

        if (!this.props.disabled) {
            return (
                <React.Fragment>
                    <input 
                        type={this.state.type} 
                        id={this.state.id} 
                        name={this.state.id} 
                        value={value} 
                        className={classname} 
                        placeholder={this.state.placeholder} 
                        onFocus={(e)=>this.handleFocus(e)} 
                        onChange={(e)=>this.handleChange(e)}
                        onBlur={(e)=>this.handleBlur(e)} />
                    {
                        this.props.show_length &&
                        <React.Fragment>
                            <br/>
                            <label className="GrayText" style={{visibility: (this.state.currentlength > 0 ? "visible":"hidden")}}>{ "入力文字数："+this.state.currentlength+" / "+this.props.length[1] }</label>
                        </React.Fragment>
                    }
                </React.Fragment>
            );
        }
        else {
            return (
                <React.Fragment>
                    <input 
                        type={this.state.type} 
                        id={this.state.id} 
                        name={this.state.id} 
                        value={value} 
                        className={classname} 
                        placeholder={this.props.placeholder} 
                        onFocus={(e)=>this.handleFocus(e)} 
                        onChange={(e)=>this.handleChange(e)}
                        onBlur={(e)=>this.handleBlur(e)}
                        disabled="disabled" />
                </React.Fragment>
            );
        }
    }
}

TextBox.propTypes = {
    id              : PropTypes.string.isRequired,
    type            : PropTypes.string.isRequired,
    value           : PropTypes.string,
    classname       : PropTypes.string,
    placeholder     : PropTypes.string,
    length          : PropTypes.array,
    disabled        : PropTypes.bool,
    validate_id     : PropTypes.string,
    validate        : PropTypes.array,
    state           : PropTypes.number.isRequired,
    validatestate   : PropTypes.bool,
    show_length     : PropTypes.bool,
    callback        : PropTypes.func.isRequired
}

export default TextBox;




// WEBPACK FOOTER //
// ./src/modules/TextBox.js